angular
    .module('empower.control')
    .directive("datevalidate", function () {
        return {
            require: '^form',
            restrict: 'A',
            link: function (scope, element, attrs, ctrl) {
                scope.$watch(attrs["ngModel"], function (evt) {
                    setTimeout(function () {

                        var formatter = "DD-MM-YYYY";
                        var newDate = $(element).val();
                        var maxDate = attrs.maxdate ? moment(attrs.maxdate, formatter) : null;
                        var minDate = attrs.mindate ? moment(attrs.mindate, formatter) : null;
                        var date = moment(newDate, formatter);
                        var isValid = date.isValid();
                        ctrl[element[0].name].$setValidity("Invalid_Max_Date", true);
                        ctrl[element[0].name].$setValidity("Invalid_Date", true);
                        ctrl[element[0].name].$setValidity("Invalid_Min_Date", true);

                        if (!isValid && newDate && newDate != 'dd/mm/yyyy') {
                            ctrl[element[0].name].$setValidity("Invalid_Date", false);
                        } else {
                            if (maxDate && maxDate.isValid() && date.isAfter(maxDate)) {
                                ctrl[element[0].name].$setValidity("Invalid_Max_Date", false);
                            } else if (minDate && minDate.isValid() && date.isBefore(minDate)) {
                                ctrl[element[0].name].$setValidity("Invalid_Min_Date", false);
                            } else {
                            }
                        }
                        scope.$apply();
                    }, 0);
                })

            } // link
        };
    })